import { useEffect, useState } from "react";
import UserService from "services/UsuarioService";
import {
  getHelpCenterPermissionsFromStorage,
  getUserIdFromStorage,
} from "shared/storageUtils";

type UseHelpCenterProps = {
  clientPermissions?: { canAccess: boolean; supportAvailable: boolean } | null;
};

export function useHelpCenter({ clientPermissions }: UseHelpCenterProps) {
  const [helpCenterPermissions, setHelpCenterPermissions] = useState({
    canAccess: false,
    supportAvailable: false,
  });

  useEffect(() => {
    const permissionsFromStorage = getHelpCenterPermissionsFromStorage();

    setHelpCenterPermissions({
      canAccess:
        clientPermissions?.canAccess ?? permissionsFromStorage.canAccess,
      supportAvailable:
        clientPermissions?.supportAvailable ??
        permissionsFromStorage.supportAvailable,
    });
  }, [clientPermissions?.canAccess, clientPermissions?.supportAvailable]);

  const handleGetHelpCenterToken = async (): Promise<string | null> => {
    try {
      const userId = getUserIdFromStorage();
      if (userId == null) return null;
      const response = await UserService.tokenCentralAjuda(
        userId,
        helpCenterPermissions.supportAvailable
      );
      return response.data.token;
    } catch (error) {
      return null;
    }
  };

  return {
    handleGetHelpCenterToken,
    helpCenterPermissions,
  };
}
